import { render } from "./EmployeeView.vue?vue&type=template&id=543e69d4&ts=true"
import script from "./EmployeeView.vue?vue&type=script&lang=ts"
export * from "./EmployeeView.vue?vue&type=script&lang=ts"

import "./EmployeeView.vue?vue&type=style&index=0&id=543e69d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__